package xyz.malefic.multipage.styles

import org.jetbrains.compose.web.css.rgba

object Theme {
    // Professional muted colors — calm and trustworthy
    val Primary = rgba(72, 90, 120, 1.0f)         // Deep slate blue
    val PrimaryLight = rgba(120, 140, 170, 1.0f)   // Lighter slate
    val PrimaryDark = rgba(45, 60, 85, 1.0f)       // Darker slate

    // Warm accent — muted gold
    val Secondary = rgba(180, 150, 100, 1.0f)      // Muted gold
    val SecondaryLight = rgba(210, 185, 140, 1.0f)
    val SecondaryDark = rgba(150, 120, 70, 1.0f)

    // Accent — soft green for trust
    val Accent = rgba(100, 140, 110, 1.0f)         // Muted green
    val AccentLight = rgba(140, 175, 150, 1.0f)
    val AccentDark = rgba(60, 100, 70, 1.0f)

    // Background — warm neutrals
    val Background = rgba(250, 248, 245, 1.0f)     // Warm ivory
    val Surface = rgba(255, 255, 255, 1.0f)         // Pure white
    val SurfaceVariant = rgba(245, 242, 238, 1.0f)  // Warm light gray

    // Text — high contrast for readability
    val TextPrimary = rgba(40, 45, 55, 1.0f)       // Near-black
    val TextSecondary = rgba(90, 95, 105, 1.0f)    // Medium gray
    val TextTertiary = rgba(140, 145, 155, 1.0f)   // Light gray

    // Status colors
    val Error = rgba(180, 60, 60, 1.0f)
    val Warning = rgba(200, 150, 50, 1.0f)
    val Success = rgba(70, 150, 80, 1.0f)
    val Info = rgba(70, 130, 180, 1.0f)

    // Font families (Japanese-ready)
    val FontFamily = "'Noto Sans JP', 'M PLUS Rounded 1c', -apple-system, BlinkMacSystemFont, sans-serif"
    val FontFamilyHeading = "'Zen Kurenaido', 'Shippori Mincho', serif"
    val HeadingFontFamily = "'Zen Kurenaido', 'Shippori Mincho', serif"
    val FontFamilyMono = "'JetBrains Mono', 'Fira Code', monospace"

    // Shadows
    val ShadowSmall = "0 2px 4px rgba(0,0,0,0.08)"
    val ShadowMedium = "0 4px 8px rgba(0,0,0,0.12)"
    val ShadowLarge = "0 8px 16px rgba(0,0,0,0.16)"
    val ShadowColor = rgba(0, 0, 0, 0.08f)

    // Border radius (numeric values for modifiers)
    val RadiusSm = 4
    val RadiusMd = 8
    val RadiusLg = 16
    val RadiusXl = 24

    // Border colors
    val BorderLight = rgba(220, 218, 215, 1.0f)

    // Z-index values
    val ZIndexSticky = 100
    val ZIndexModal = 1000
    val ZIndexTooltip = 1100
}
